import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import * as firebase from 'firebase'

import PaymentDueInput from 'billing/common/modules/header/paymentDue/PaymentDueInput'
import BillDateInput from 'billing/common/modules/header/billDate/BillDateInput'
import BillCustomerSelector from 'billing/common/modules/header/BillCustomerSelector'
import ReferencedEventsList from './ReferencedEventsList'
import CustomerEventsSelector from './CustomerEventsSelector'

import Styles from 'billing/common/Styles'

const InvoiceTitleInput = ({ value, onChange }) => {
  return (
    <input
      style={styles.input(275)}
      value={value}
      onChange={onChange}/>
  )
}

InvoiceTitleInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

const InvoiceNumberInput = ({ value, onChange }) => {
  return (
    <input
      style={styles.input()}
      value={value}
      type='number'
      step='1'
      onChange={onChange}/>
  )
}

InvoiceNumberInput.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}

class InvoiceHeader extends React.Component {

  static propTypes = {
    invoiceEditor: PropTypes.object.isRequired,
    uploadedCompanyLogo: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.getCompanyLogoUrl()
  }

  getCompanyLogoStoragePath = () => {
    return `team_logo/${this.props.invoiceEditor.getTeamId()}/small_logo`
  }

  getCompanyLogoUrl = () => {
    firebase.storage().ref().child(this.getCompanyLogoStoragePath())
      .getDownloadURL()
      .then(companyLogoUrl => { this.setState({ companyLogoUrl }) })
  }

  handleInvoiceNumberChanged = event => {
    const value = parseInt(event.target.value)
    this.props.invoiceEditor.setNumber(isNaN(value) ? 0 : value)
  }

  handleInvoiceTitleChanged = event => {
    this.props.invoiceEditor.setTitle(event.target.value)
  }

  handleCustomerSelectionChanged = customerInfo => {
    this.props.invoiceEditor.setCustomerInfo(customerInfo)
  }

  handleEventSelected = eventInfo => {
    this.props.invoiceEditor.addReferencedEvent(eventInfo)
  }

  handleEventRemoveRequested = eventInfo => {
    this.props.invoiceEditor.removeReferencedEvent(eventInfo)
  }

  render() {
    const dueDate = this.props.invoiceEditor.getPaymentDueDate().startOf('day')
    const invoiceDate = this.props.invoiceEditor.getBillDate().startOf('day')
    const days = dueDate.diff(invoiceDate, 'days')
    const dueStr = days > 0 ? `Within ${days} day${days > 1 ? 's' : ''}` : 'On Receipt'
    const invoice = this.props.invoiceEditor.getBillingEntity()
    const customer = invoice ? { name: invoice.customerName } : null
    return (
      <div style={styles.container}>
        <div style={styles.topContainer}>
          { this.props.uploadedCompanyLogo
            ? <img src={this.state.companyLogoUrl} width={121} height={121} />
            : <div style={Styles.noLogoBox}>Logo</div>
          }
          <div>
            <div style={styles.inputContainer()}>
              <div style={styles.inputLabel}>Invoice Number</div>
              <InvoiceNumberInput
                value={this.props.invoiceEditor.getNumber()}
                onChange={this.handleInvoiceNumberChanged}/>
            </div>
            <div style={styles.inputContainer()}>
              <div style={styles.inputLabel}>Invoice Date</div>
              <BillDateInput billEditor={this.props.invoiceEditor} billingEntity='invoice' />
            </div>
            <div style={styles.inputContainer(4)}>
              <div style={styles.inputLabel}>Payment Due</div>
              <PaymentDueInput billEditor={this.props.invoiceEditor} billingEntity='invoice' />
            </div>
            <div style={styles.inputContainer(0)}>
              <div />
              <div style={{ width: 170 }}>{ dueStr }</div>
            </div>
          </div>
        </div>
        <div style={styles.bottomContainer}>
          <div style={styles.titleContainer}>
            <div style={styles.titleLabel}>Invoice Title</div>
            <InvoiceTitleInput
              value={this.props.invoiceEditor.getTitle()}
              onChange={this.handleInvoiceTitleChanged}/>
          </div>
          <BillCustomerSelector
            customer={customer}
            customerId={this.props.invoiceEditor.getCustomerId()}
            contactId={this.props.invoiceEditor.getContactId()}
            onCustomerSelectionChanged={this.handleCustomerSelectionChanged} />
          <CustomerEventsSelector
            customerId={this.props.invoiceEditor.getCustomerId()}
            contactId={this.props.invoiceEditor.getContactId()}
            teamId={this.props.invoiceEditor.getTeamId()}
            onEventSelected={this.handleEventSelected} />
          <ReferencedEventsList
            style={{ marginTop: 8 }}
            onEventRemoveRequested={this.handleEventRemoveRequested}
            invoiceEditor={this.props.invoiceEditor} />
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 12,
    fontSize: 14
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 8
  },
  inputContainer: margiBottom => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: margiBottom || 8
  }),
  titleLabel: {
    marginBottom: 4
  },
  inputLabel: {
    marginRight: 6
  },
  input: width => ({
    width,
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    color: '#4a4a4a',
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    outlineWidth: 2
  })
}

const mapStateToProps = state => ({
  uploadedCompanyLogo: state.firebase.team.metadata.value.uploadedCompanyLogo
})

export default connect(mapStateToProps)(InvoiceHeader)



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/header/InvoiceHeader.js